import { faCheck, faSignInAlt, faTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { Card, Col, Container, Row } from 'react-bootstrap';
import { Helmet } from 'react-helmet-async';
import { NavLink, useNavigate } from 'react-router-dom';
import { useLogIn } from '../../Auth/Hooks/useLogIn';
import { LogInForm } from '../../Auth/Components/LogInForm';
import { useAuth } from '../../../Contexts/AuthProvider';

/**
 * Login page under the home section.
 */
export const LogIn = () => {
  const navigate = useNavigate();
  const { loginWithTokens } = useAuth();

  const { handleSubmit, error } = useLogIn({
    onSuccess: (response) => {
      loginWithTokens({ accessToken: response.access_token, expiry: response.expiry }).then(
        (user) => {
          navigate('/agent');
        }
      );
    },
  });

  return (
    <>
      <Helmet>
        <title>Log In</title>
      </Helmet>
      <div className="intro mb-5">
        <Container className="max-w-xl pt-5 pb-5">
          <Row className="pt-2 mt-5">
            <Col lg={5} className="pt-2">
              <h1 className="fw-bold mt-5 text-white">Log in to your CRM</h1>
              <p className="text-white lead">or explore by registering</p>
              <NavLink className="btn btn-primary" to="/home/sign-up" end>
                Start Free Trial
              </NavLink>
            </Col>
            <Col lg={7}>
              <Card className="border bg-white">
                <div className="card-icon">
                  <FontAwesomeIcon icon={faSignInAlt} />
                </div>
                <Card.Body className="p-4">
                  <LogInForm onSubmit={handleSubmit} errorMessage={error ?? undefined} />
                </Card.Body>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </>
  );
};
